<template>
    <div class="survey-modal">
        <img class="close" src="../../assets/app-icons/event-details/close.svg" alt="Zatvori" v-on:click="$emit('close')" />
        <div class="event-name">{{event.name}} ({{event.type === 'Lecture' ? 'Predavanje' : event.type === 'Workshop' ? 'Radionica' : event.type === 'FlyTalk' ? 'Fly talk' : 'Campfire talk'}})</div>
        <span class="event-users" v-for="(eventUser, index) in event.eventUsers" v-bind:key="eventUser.userId">
            <span v-if="eventUser.user">
                {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}<span v-if="eventUser.user && eventUser.user.lecturerTitle"> ({{ eventUser.user.lecturerTitle }})</span><span v-if="index !== event.eventUsers.length - 1">, </span>
            </span>
        </span>
        <div class="survey-part" v-for="surveyQuestion in surveyQuestions" v-bind:key="surveyQuestion.id">
            <div class="question-text">{{surveyQuestion.question}}</div>        
            <input type="text" />
        </div>
        <button class="submit-survey" v-on:click="submitSurvey">PREDAJ</button>
    </div>
</template>

<script>
    export default {
        name: 'SurveyModal',
        data() {
            return {
                surveyQuestions: [],
                surveyData: ''
            }
        },
        props: {
            event: {}
        },
        methods: {
            submitSurvey: function() {
                if(this.isSubmitButtonDisabled)
                {
                    alert('Nisu unesene sve potrebne informacije.');
                    return;
                }

                let inputs = document.querySelectorAll('.survey-modal input');

                for(let i = 0; i < this.surveyQuestions.length; i++)
                {
                    if(!inputs[i].value || inputs[i].value.length < 5)
                    {
                        this.surveyData = '';
                        alert('Molimo te da ispuniš svaki odgovor sa bar par riječi.');
                        return;
                    }

                    this.surveyData += `Pitanje: ${this.surveyQuestions[i].question} Odgovor: ${inputs[i].value} `;
                }

                this.$emit('submit', this.event.id, this.surveyData);
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/survey-questions/all-survey-questions-for-event-type`, {
                    params: {
                        isForWorkshop: this.event.type === 'Workshop'
                    }
                })
            .then(response => {
                this.surveyQuestions = response.data;
            });
        },
        mounted() {
            document.body.classList.add('modal-open');
        },
        beforeDestroy() {
            document.body.classList.remove('modal-open');
        }
    }
</script>

<style scoped>
.survey-modal {
    font-family: "Fuse V.2 Display";
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: #fff;
    overflow-y: scroll;
}

.close:hover {
    cursor: pointer;
}

.submit-survey {
    border: none;
    background-color: #30cec1;
    color: white;
    float: right;
    margin-right: 30px;
    padding: 7px 10px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.submit-survey:hover {
    cursor: pointer;
}

.survey-part {
    margin-top: 10px;
    padding-left: 20px;
}

.survey-part input {
    border-radius: 4px;
    border: 1px solid gray;
    width: 80%;
    margin-top: 5px;
    margin-bottom: 20px;
}

.event-name,
.event-users {
    display: inline-block;
    width: 80%;
    padding-left: 20px;
}

.event-name {
    margin-bottom: 10px;
}
</style>